module.exports = __webpack_public_path__ + "static/images/b-zs.e90e10c.png";